export default "__VITE_ASSET__CNx2kT4J__"